import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AMOUNTS } from './options/amount';
import { APPROVAL_TYPES } from './options/approval-type';
import { CREATE_DATES } from './options/create-date';
import { FULFILLMENT_STATUSES } from './options/fulfillmentStatuses';
import {
  ApprovalTypeMessages,
  PaymentTypeMessages,
  RequestLineItemTypeMessages,
  ReturnShipmentStatusMessages,
  StatusMessages,
} from './options/messages';
import { REFUND_METHODS } from './options/refund-method';
import { RETURN_EXCHANGE_TYPE } from './options/return-exchange-type';
import { STATUS } from './options/status';

const buildCriterionArgumentObject = (id, displayMessage, value) => {
  return {
    id,
    displayName: <FormattedMessage {...displayMessage} />,
    value,
  };
};

const staticCriteriaArguments = {
  [APPROVAL_TYPES]: Object.keys(ApprovalTypeMessages).map((key) => buildCriterionArgumentObject(key, ApprovalTypeMessages[key], key)),
  [REFUND_METHODS]: Object.keys(PaymentTypeMessages).map((key) => buildCriterionArgumentObject(key, PaymentTypeMessages[key], key)),
  [RETURN_EXCHANGE_TYPE]: Object.keys(RequestLineItemTypeMessages).map((key) =>
    buildCriterionArgumentObject(key, RequestLineItemTypeMessages[key], key),
  ),
  [FULFILLMENT_STATUSES]: Object.keys(ReturnShipmentStatusMessages).map((key) =>
    buildCriterionArgumentObject(key, ReturnShipmentStatusMessages[key], key),
  ),
  [STATUS]: Object.keys(StatusMessages).map((key) => buildCriterionArgumentObject(key, StatusMessages[key], key)),
  [CREATE_DATES]: [],
  [AMOUNTS]: [],
};

export default staticCriteriaArguments;
